import Draft from "draft-js"

export const convertOBlocksFromText = (str: string) =>
  str.split("\n").map(lineText => ({
    key: Draft.genKey(),
    text: lineText,
    inlineStyleRanges: [],
  }))
